import { useQuery } from "@tanstack/react-query";
import { getAuthToken } from "@/components/aiChat/chatAuth";

const useConversations = (companyId, queryOptions = {}) =>
  useQuery({
    ...queryOptions,
    enabled: Boolean(companyId) && queryOptions.enabled !== false,
    queryKey: ["aiAgentConversations", companyId],
    queryFn: async () => {
      const response = await fetch("/api/ai-agent/conversations", {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          "x-company-id": companyId,
        },
      });

      if (!response.ok) {
        throw new Error("Could not load conversations");
      }

      return response.json();
    },
  });

export { useConversations };
